import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sizeFull",
  "use": "sizeFull-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"sizeFull\"><path d=\"M4.414 15H8v-5H3v3.586l3.414-3.414 1.414 1.414L4.414 15zm9.35-12H10v5h5V4.237L11.497 7.74 10.26 6.503 13.763 3h.001zM10 1h7v7h-7V1zM8 17H1v-7h7v7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol